import { initialize } from '@baloise/ds-core';
import React, { createElement, Fragment } from 'react';
import { jsx } from 'react/jsx-runtime';
import 'react-dom';
import { defineCustomElements } from '@baloise/ds-core/loader';

function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}

function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _instanceof1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else return _instanceof(left, right);
}

function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

var dashToPascalCase = function(str) {
    return str.toLowerCase().split('-').map(function(segment) {
        return segment.charAt(0).toUpperCase() + segment.slice(1);
    }).join('');
};
var camelToDashCase = function(str) {
    return str.replace(/([A-Z])/g, function(m) {
        return "-" + m[0].toLowerCase();
    });
};

var attachProps = function(node, newProps, oldProps) {
    if (oldProps === undefined) oldProps = {};
    // some test frameworks don't render DOM elements, so we test here to make sure we are dealing with DOM first
    if (_instanceof1(node, Element)) {
        // add any classes in className to the class list
        var className = getClassName(node.classList, newProps, oldProps);
        if (className !== '') {
            node.className = className;
        }
        Object.keys(newProps).forEach(function(name) {
            if (name === 'children' || name === 'style' || name === 'ref' || name === 'class' || name === 'className' || name === 'forwardedRef') {
                return;
            }
            if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
                var eventName = name.substring(2);
                var eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);
                if (!isCoveredByReact(eventNameLc)) {
                    syncEvent(node, eventNameLc, newProps[name]);
                }
            } else {
                node[name] = newProps[name];
                var propType = _type_of(newProps[name]);
                if (propType === 'string') {
                    node.setAttribute(camelToDashCase(name), newProps[name]);
                }
            }
        });
    }
};
var getClassName = function(classList, newProps, oldProps) {
    var newClassProp = newProps.className || newProps.class;
    var oldClassProp = oldProps.className || oldProps.class;
    // map the classes to Maps for performance
    var currentClasses = arrayToMap(classList);
    var incomingPropClasses = arrayToMap(newClassProp ? newClassProp.split(' ') : []);
    var oldPropClasses = arrayToMap(oldClassProp ? oldClassProp.split(' ') : []);
    var finalClassNames = [];
    // loop through each of the current classes on the component
    // to see if it should be a part of the classNames added
    currentClasses.forEach(function(currentClass) {
        if (incomingPropClasses.has(currentClass)) {
            // add it as its already included in classnames coming in from newProps
            finalClassNames.push(currentClass);
            incomingPropClasses.delete(currentClass);
        } else if (!oldPropClasses.has(currentClass)) {
            // add it as it has NOT been removed by user
            finalClassNames.push(currentClass);
        }
    });
    incomingPropClasses.forEach(function(s) {
        return finalClassNames.push(s);
    });
    return finalClassNames.join(' ');
};
/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ var isCoveredByReact = function(eventNameSuffix) {
    if (typeof document === 'undefined') {
        return true;
    } else {
        var eventName = 'on' + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
    }
};
var syncEvent = function(node, eventName, newEventHandler) {
    var eventStore = node.__events || (node.__events = {});
    var oldEventHandler = eventStore[eventName];
    // Remove old listener so they don't double up.
    if (oldEventHandler) {
        node.removeEventListener(eventName, oldEventHandler);
    }
    // Bind new listener.
    node.addEventListener(eventName, eventStore[eventName] = function handler(e) {
        if (newEventHandler) {
            newEventHandler.call(this, e);
        }
    });
};
var arrayToMap = function(arr) {
    var map = new Map();
    arr.forEach(function(s) {
        return map.set(s, s);
    });
    return map;
};

var setRef = function(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    } else if (ref != null) {
        ref.current = value;
    }
};
var mergeRefs = function() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(value) {
        refs.forEach(function(ref) {
            setRef(ref, value);
        });
    };
};
var createForwardRef = function(ReactComponent, displayName) {
    var forwardRef = function(props, ref) {
        return /*#__PURE__*/ jsx(ReactComponent, _extends({}, props, {
            forwardedRef: ref
        }));
    };
    forwardRef.displayName = displayName;
    return /*#__PURE__*/ React.forwardRef(forwardRef);
};

var createReactComponent = function(tagName, ReactComponentContext, manipulatePropsFunction, defineCustomElement) {
    var displayName = dashToPascalCase(tagName);
    var ReactComponent = /*#__PURE__*/ function(_React_Component) {
        _inherits(ReactComponent, _React_Component);
        function ReactComponent(props) {
            var _this;
            _this = _React_Component.call(this, props) || this;
            _this.setComponentElRef = function(element) {
                _this.componentEl = element;
            };
            return _this;
        }
        var _proto = ReactComponent.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this.componentDidUpdate(this.props);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
            attachProps(this.componentEl, this.props, prevProps);
        };
        _proto.render = function render() {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
            var _this_props = this.props, children = _this_props.children, forwardedRef = _this_props.forwardedRef, style = _this_props.style; _this_props.className; _this_props.ref; var cProps = _object_without_properties_loose(_this_props, [
                "children",
                "forwardedRef",
                "style",
                "className",
                "ref"
            ]);
            var propsToPass = Object.keys(cProps).reduce(function(acc, name) {
                if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
                    var eventName = name.substring(2).toLowerCase();
                    if (typeof document !== 'undefined' && isCoveredByReact(eventName)) {
                        acc[name] = cProps[name];
                    }
                } else {
                    acc[name] = cProps[name];
                }
                return acc;
            }, {});
            var newProps = _extends({}, propsToPass, {
                ref: mergeRefs(forwardedRef, this.setComponentElRef),
                style: style
            });
            /**
       * We use createElement here instead of
       * React.createElement to work around a
       * bug in Vite (https://github.com/vitejs/vite/issues/6104).
       * React.createElement causes all elements to be rendered
       * as <tagname> instead of the actual Web Component.
       */ var areChildrenEmpty = children === '' || children === undefined || children === null;
            var fragment = !areChildrenEmpty ? /*#__PURE__*/ createElement(Fragment, {}, children) : /*#__PURE__*/ createElement(Fragment, {}, ' ');
            var component = /*#__PURE__*/ createElement(tagName, newProps, fragment);
            return component;
        };
        _create_class(ReactComponent, null, [
            {
                key: "displayName",
                get: function get() {
                    return displayName;
                }
            }
        ]);
        return ReactComponent;
    }(React.Component);
    return createForwardRef(ReactComponent, displayName);
};

defineCustomElements();
var BalAccordion = /*@__PURE__*/ createReactComponent('bal-accordion');
var BalAccordionDetails = /*@__PURE__*/ createReactComponent('bal-accordion-details');
var BalAccordionSummary = /*@__PURE__*/ createReactComponent('bal-accordion-summary');
var BalAccordionTrigger = /*@__PURE__*/ createReactComponent('bal-accordion-trigger');
var BalApp = /*@__PURE__*/ createReactComponent('bal-app');
var BalBadge = /*@__PURE__*/ createReactComponent('bal-badge');
var BalButton = /*@__PURE__*/ createReactComponent('bal-button');
var BalButtonGroup = /*@__PURE__*/ createReactComponent('bal-button-group');
var BalCard = /*@__PURE__*/ createReactComponent('bal-card');
var BalCardActions = /*@__PURE__*/ createReactComponent('bal-card-actions');
var BalCardButton = /*@__PURE__*/ createReactComponent('bal-card-button');
var BalCardContent = /*@__PURE__*/ createReactComponent('bal-card-content');
var BalCardSubtitle = /*@__PURE__*/ createReactComponent('bal-card-subtitle');
var BalCardTitle = /*@__PURE__*/ createReactComponent('bal-card-title');
var BalCarousel = /*@__PURE__*/ createReactComponent('bal-carousel');
var BalCarouselItem = /*@__PURE__*/ createReactComponent('bal-carousel-item');
var BalCheckbox = /*@__PURE__*/ createReactComponent('bal-checkbox');
var BalCheckboxButton = /*@__PURE__*/ createReactComponent('bal-checkbox-button');
var BalCheckboxGroup = /*@__PURE__*/ createReactComponent('bal-checkbox-group');
var BalClose = /*@__PURE__*/ createReactComponent('bal-close');
var BalContent = /*@__PURE__*/ createReactComponent('bal-content');
var BalData = /*@__PURE__*/ createReactComponent('bal-data');
var BalDataItem = /*@__PURE__*/ createReactComponent('bal-data-item');
var BalDataLabel = /*@__PURE__*/ createReactComponent('bal-data-label');
var BalDataValue = /*@__PURE__*/ createReactComponent('bal-data-value');
var BalDate = /*@__PURE__*/ createReactComponent('bal-date');
var BalDateCalendar = /*@__PURE__*/ createReactComponent('bal-date-calendar');
var BalDateCalendarCell = /*@__PURE__*/ createReactComponent('bal-date-calendar-cell');
var BalDivider = /*@__PURE__*/ createReactComponent('bal-divider');
var BalDropdown = /*@__PURE__*/ createReactComponent('bal-dropdown');
var BalField = /*@__PURE__*/ createReactComponent('bal-field');
var BalFieldControl = /*@__PURE__*/ createReactComponent('bal-field-control');
var BalFieldHint = /*@__PURE__*/ createReactComponent('bal-field-hint');
var BalFieldLabel = /*@__PURE__*/ createReactComponent('bal-field-label');
var BalFieldMessage = /*@__PURE__*/ createReactComponent('bal-field-message');
var BalFileUpload = /*@__PURE__*/ createReactComponent('bal-file-upload');
var BalFooter = /*@__PURE__*/ createReactComponent('bal-footer');
var BalForm = /*@__PURE__*/ createReactComponent('bal-form');
var BalFormCol = /*@__PURE__*/ createReactComponent('bal-form-col');
var BalFormGrid = /*@__PURE__*/ createReactComponent('bal-form-grid');
var BalHeading = /*@__PURE__*/ createReactComponent('bal-heading');
var BalHint = /*@__PURE__*/ createReactComponent('bal-hint');
var BalHintText = /*@__PURE__*/ createReactComponent('bal-hint-text');
var BalHintTitle = /*@__PURE__*/ createReactComponent('bal-hint-title');
var BalIcon = /*@__PURE__*/ createReactComponent('bal-icon');
var BalInput = /*@__PURE__*/ createReactComponent('bal-input');
var BalInputDate = /*@__PURE__*/ createReactComponent('bal-input-date');
var BalInputGroup = /*@__PURE__*/ createReactComponent('bal-input-group');
var BalInputSlider = /*@__PURE__*/ createReactComponent('bal-input-slider');
var BalInputStepper = /*@__PURE__*/ createReactComponent('bal-input-stepper');
var BalLabel = /*@__PURE__*/ createReactComponent('bal-label');
var BalList = /*@__PURE__*/ createReactComponent('bal-list');
var BalListItem = /*@__PURE__*/ createReactComponent('bal-list-item');
var BalListItemAccordionBody = /*@__PURE__*/ createReactComponent('bal-list-item-accordion-body');
var BalListItemAccordionHead = /*@__PURE__*/ createReactComponent('bal-list-item-accordion-head');
var BalListItemContent = /*@__PURE__*/ createReactComponent('bal-list-item-content');
var BalListItemIcon = /*@__PURE__*/ createReactComponent('bal-list-item-icon');
var BalListItemSubtitle = /*@__PURE__*/ createReactComponent('bal-list-item-subtitle');
var BalListItemTitle = /*@__PURE__*/ createReactComponent('bal-list-item-title');
var BalLogo = /*@__PURE__*/ createReactComponent('bal-logo');
var BalModal = /*@__PURE__*/ createReactComponent('bal-modal');
var BalModalBody = /*@__PURE__*/ createReactComponent('bal-modal-body');
var BalModalHeader = /*@__PURE__*/ createReactComponent('bal-modal-header');
var BalNav = /*@__PURE__*/ createReactComponent('bal-nav');
var BalNavLink = /*@__PURE__*/ createReactComponent('bal-nav-link');
var BalNavLinkGrid = /*@__PURE__*/ createReactComponent('bal-nav-link-grid');
var BalNavLinkGridCol = /*@__PURE__*/ createReactComponent('bal-nav-link-grid-col');
var BalNavLinkGroup = /*@__PURE__*/ createReactComponent('bal-nav-link-group');
var BalNavMenuBar = /*@__PURE__*/ createReactComponent('bal-nav-menu-bar');
var BalNavMenuFlyout = /*@__PURE__*/ createReactComponent('bal-nav-menu-flyout');
var BalNavMetaBar = /*@__PURE__*/ createReactComponent('bal-nav-meta-bar');
var BalNavbar = /*@__PURE__*/ createReactComponent('bal-navbar');
var BalNavbarBrand = /*@__PURE__*/ createReactComponent('bal-navbar-brand');
var BalNavbarMenu = /*@__PURE__*/ createReactComponent('bal-navbar-menu');
var BalNavbarMenuEnd = /*@__PURE__*/ createReactComponent('bal-navbar-menu-end');
var BalNavbarMenuStart = /*@__PURE__*/ createReactComponent('bal-navbar-menu-start');
var BalNotices = /*@__PURE__*/ createReactComponent('bal-notices');
var BalNotification = /*@__PURE__*/ createReactComponent('bal-notification');
var BalNumberInput = /*@__PURE__*/ createReactComponent('bal-number-input');
var BalOption = /*@__PURE__*/ createReactComponent('bal-option');
var BalOptionList = /*@__PURE__*/ createReactComponent('bal-option-list');
var BalPagination = /*@__PURE__*/ createReactComponent('bal-pagination');
var BalPopover = /*@__PURE__*/ createReactComponent('bal-popover');
var BalPopoverContent = /*@__PURE__*/ createReactComponent('bal-popover-content');
var BalPopup = /*@__PURE__*/ createReactComponent('bal-popup');
var BalProgressBar = /*@__PURE__*/ createReactComponent('bal-progress-bar');
var BalRadio = /*@__PURE__*/ createReactComponent('bal-radio');
var BalRadioButton = /*@__PURE__*/ createReactComponent('bal-radio-button');
var BalRadioGroup = /*@__PURE__*/ createReactComponent('bal-radio-group');
var BalSegment = /*@__PURE__*/ createReactComponent('bal-segment');
var BalSegmentItem = /*@__PURE__*/ createReactComponent('bal-segment-item');
var BalSelect = /*@__PURE__*/ createReactComponent('bal-select');
var BalSelectOption = /*@__PURE__*/ createReactComponent('bal-select-option');
var BalShape = /*@__PURE__*/ createReactComponent('bal-shape');
var BalSheet = /*@__PURE__*/ createReactComponent('bal-sheet');
var BalSnackbar = /*@__PURE__*/ createReactComponent('bal-snackbar');
var BalSpinner = /*@__PURE__*/ createReactComponent('bal-spinner');
var BalStack = /*@__PURE__*/ createReactComponent('bal-stack');
var BalStage = /*@__PURE__*/ createReactComponent('bal-stage');
var BalStageBackLink = /*@__PURE__*/ createReactComponent('bal-stage-back-link');
var BalStageBody = /*@__PURE__*/ createReactComponent('bal-stage-body');
var BalStageFoot = /*@__PURE__*/ createReactComponent('bal-stage-foot');
var BalStageHead = /*@__PURE__*/ createReactComponent('bal-stage-head');
var BalStageImage = /*@__PURE__*/ createReactComponent('bal-stage-image');
var BalStepItem = /*@__PURE__*/ createReactComponent('bal-step-item');
var BalSteps = /*@__PURE__*/ createReactComponent('bal-steps');
var BalTabItem = /*@__PURE__*/ createReactComponent('bal-tab-item');
var BalTable = /*@__PURE__*/ createReactComponent('bal-table');
var BalTabs = /*@__PURE__*/ createReactComponent('bal-tabs');
var BalTag = /*@__PURE__*/ createReactComponent('bal-tag');
var BalTagGroup = /*@__PURE__*/ createReactComponent('bal-tag-group');
var BalText = /*@__PURE__*/ createReactComponent('bal-text');
var BalTextarea = /*@__PURE__*/ createReactComponent('bal-textarea');
var BalTimeInput = /*@__PURE__*/ createReactComponent('bal-time-input');
var BalToast = /*@__PURE__*/ createReactComponent('bal-toast');
var BalTooltip = /*@__PURE__*/ createReactComponent('bal-tooltip');

var useBaloiseDesignSystem = function(config) {
    if (config === undefined) config = {};
    initialize(_extends({}, config.defaults, {
        httpFormSubmit: false
    }));
};

export { BalAccordion, BalAccordionDetails, BalAccordionSummary, BalAccordionTrigger, BalApp, BalBadge, BalButton, BalButtonGroup, BalCard, BalCardActions, BalCardButton, BalCardContent, BalCardSubtitle, BalCardTitle, BalCarousel, BalCarouselItem, BalCheckbox, BalCheckboxButton, BalCheckboxGroup, BalClose, BalContent, BalData, BalDataItem, BalDataLabel, BalDataValue, BalDate, BalDateCalendar, BalDateCalendarCell, BalDivider, BalDropdown, BalField, BalFieldControl, BalFieldHint, BalFieldLabel, BalFieldMessage, BalFileUpload, BalFooter, BalForm, BalFormCol, BalFormGrid, BalHeading, BalHint, BalHintText, BalHintTitle, BalIcon, BalInput, BalInputDate, BalInputGroup, BalInputSlider, BalInputStepper, BalLabel, BalList, BalListItem, BalListItemAccordionBody, BalListItemAccordionHead, BalListItemContent, BalListItemIcon, BalListItemSubtitle, BalListItemTitle, BalLogo, BalModal, BalModalBody, BalModalHeader, BalNav, BalNavLink, BalNavLinkGrid, BalNavLinkGridCol, BalNavLinkGroup, BalNavMenuBar, BalNavMenuFlyout, BalNavMetaBar, BalNavbar, BalNavbarBrand, BalNavbarMenu, BalNavbarMenuEnd, BalNavbarMenuStart, BalNotices, BalNotification, BalNumberInput, BalOption, BalOptionList, BalPagination, BalPopover, BalPopoverContent, BalPopup, BalProgressBar, BalRadio, BalRadioButton, BalRadioGroup, BalSegment, BalSegmentItem, BalSelect, BalSelectOption, BalShape, BalSheet, BalSnackbar, BalSpinner, BalStack, BalStage, BalStageBackLink, BalStageBody, BalStageFoot, BalStageHead, BalStageImage, BalStepItem, BalSteps, BalTabItem, BalTable, BalTabs, BalTag, BalTagGroup, BalText, BalTextarea, BalTimeInput, BalToast, BalTooltip, useBaloiseDesignSystem };
